export default __webpack_public_path__ + "static/media/proj5.ee3b9864.png";